/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { DlmAccessLevel } from '../models/dlm-access-level';
import { EmployeeEmploymentDetails } from '../models/employee-employment-details';
import { EmployeeEmploymentDetailsDlmBaseResponse } from '../models/employee-employment-details-dlm-base-response';
import { EmployeePersonalDetails } from '../models/employee-personal-details';
import { EmployeePersonalDetailsDlmBaseResponse } from '../models/employee-personal-details-dlm-base-response';
import { EmployeeResponse } from '../models/employee-response';
import { EmployeeResponseDlmBaseResponse } from '../models/employee-response-dlm-base-response';
import { EmployeeResponseListDlmBaseResponse } from '../models/employee-response-list-dlm-base-response';
import { UserDtoListBaseResponse } from '../models/user-dto-list-base-response';
import { UserDtoValidatorResponse } from '../models/user-dto-validator-response';
import { UsersByStaffRateDtoListBaseResponse } from '../models/users-by-staff-rate-dto-list-base-response';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiEmployeeEmployeeGet
   */
  static readonly ApiEmployeeEmployeeGetPath = '/api/Employee/employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeGet$Plain(params?: {
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEmployeeGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeGet$Json(params?: {
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEmployeeGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEmployeesGet
   */
  static readonly ApiEmployeeEmployeesGetPath = '/api/Employee/employees';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeesGet$Plain$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<EmployeeResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeesGet$Plain(params?: {
    archived?: boolean;
  }): Observable<EmployeeResponseListDlmBaseResponse> {

    return this.apiEmployeeEmployeesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseListDlmBaseResponse>) => r.body as EmployeeResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeesGet$Json$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<EmployeeResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeesGet$Json(params?: {
    archived?: boolean;
  }): Observable<EmployeeResponseListDlmBaseResponse> {

    return this.apiEmployeeEmployeesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseListDlmBaseResponse>) => r.body as EmployeeResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEmployeeUsersListGet
   */
  static readonly ApiEmployeeEmployeeUsersListGetPath = '/api/Employee/employee-users-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeUsersListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUsersListGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<UsersByStaffRateDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeUsersListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UsersByStaffRateDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeUsersListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUsersListGet$Plain(params?: {
  }): Observable<UsersByStaffRateDtoListBaseResponse> {

    return this.apiEmployeeEmployeeUsersListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<UsersByStaffRateDtoListBaseResponse>) => r.body as UsersByStaffRateDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeUsersListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUsersListGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<UsersByStaffRateDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeUsersListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UsersByStaffRateDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeUsersListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUsersListGet$Json(params?: {
  }): Observable<UsersByStaffRateDtoListBaseResponse> {

    return this.apiEmployeeEmployeeUsersListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<UsersByStaffRateDtoListBaseResponse>) => r.body as UsersByStaffRateDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeSearchEmployeeUsersGet
   */
  static readonly ApiEmployeeSearchEmployeeUsersGetPath = '/api/Employee/search-employee-users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeSearchEmployeeUsersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeSearchEmployeeUsersGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
    clockingOnly?: boolean;
  }): Observable<StrictHttpResponse<UserDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeSearchEmployeeUsersGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
      rb.query('clockingOnly', params.clockingOnly, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeSearchEmployeeUsersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeSearchEmployeeUsersGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
    clockingOnly?: boolean;
  }): Observable<UserDtoListBaseResponse> {

    return this.apiEmployeeSearchEmployeeUsersGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<UserDtoListBaseResponse>) => r.body as UserDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeSearchEmployeeUsersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeSearchEmployeeUsersGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
    clockingOnly?: boolean;
  }): Observable<StrictHttpResponse<UserDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeSearchEmployeeUsersGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
      rb.query('clockingOnly', params.clockingOnly, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeSearchEmployeeUsersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeSearchEmployeeUsersGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
    clockingOnly?: boolean;
  }): Observable<UserDtoListBaseResponse> {

    return this.apiEmployeeSearchEmployeeUsersGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<UserDtoListBaseResponse>) => r.body as UserDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEmployeeUserGet
   */
  static readonly ApiEmployeeEmployeeUserGetPath = '/api/Employee/employee-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserGet$Plain$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<UserDtoValidatorResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeUserGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDtoValidatorResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserGet$Plain(params?: {
    userId?: number;
  }): Observable<UserDtoValidatorResponse> {

    return this.apiEmployeeEmployeeUserGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<UserDtoValidatorResponse>) => r.body as UserDtoValidatorResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserGet$Json$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<UserDtoValidatorResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeUserGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDtoValidatorResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserGet$Json(params?: {
    userId?: number;
  }): Observable<UserDtoValidatorResponse> {

    return this.apiEmployeeEmployeeUserGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<UserDtoValidatorResponse>) => r.body as UserDtoValidatorResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEmployeeUserFullDetailsGet
   */
  static readonly ApiEmployeeEmployeeUserFullDetailsGetPath = '/api/Employee/employee-user-full-details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeUserFullDetailsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserFullDetailsGet$Plain$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<UserDtoValidatorResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeUserFullDetailsGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDtoValidatorResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeUserFullDetailsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserFullDetailsGet$Plain(params?: {
    userId?: number;
  }): Observable<UserDtoValidatorResponse> {

    return this.apiEmployeeEmployeeUserFullDetailsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<UserDtoValidatorResponse>) => r.body as UserDtoValidatorResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeUserFullDetailsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserFullDetailsGet$Json$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<UserDtoValidatorResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeUserFullDetailsGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDtoValidatorResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeUserFullDetailsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeUserFullDetailsGet$Json(params?: {
    userId?: number;
  }): Observable<UserDtoValidatorResponse> {

    return this.apiEmployeeEmployeeUserFullDetailsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<UserDtoValidatorResponse>) => r.body as UserDtoValidatorResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEmployeeCanClockInOutGet
   */
  static readonly ApiEmployeeEmployeeCanClockInOutGetPath = '/api/Employee/employee-can-clock-in-out';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeCanClockInOutGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeCanClockInOutGet$Plain$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeCanClockInOutGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeCanClockInOutGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeCanClockInOutGet$Plain(params?: {
    userId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiEmployeeEmployeeCanClockInOutGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeCanClockInOutGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeCanClockInOutGet$Json$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeCanClockInOutGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeCanClockInOutGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeCanClockInOutGet$Json(params?: {
    userId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiEmployeeEmployeeCanClockInOutGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEmployeeIsAManagerGet
   */
  static readonly ApiEmployeeEmployeeIsAManagerGetPath = '/api/Employee/employee-is-a-manager';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeIsAManagerGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeIsAManagerGet$Plain$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeIsAManagerGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeIsAManagerGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeIsAManagerGet$Plain(params?: {
    userId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiEmployeeEmployeeIsAManagerGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeIsAManagerGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeIsAManagerGet$Json$Response(params?: {
    userId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeIsAManagerGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeIsAManagerGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeIsAManagerGet$Json(params?: {
    userId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiEmployeeEmployeeIsAManagerGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeCreateEmployeePost
   */
  static readonly ApiEmployeeCreateEmployeePostPath = '/api/Employee/create-employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeCreateEmployeePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeCreateEmployeePost$Plain$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeCreateEmployeePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeCreateEmployeePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeCreateEmployeePost$Plain(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeCreateEmployeePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeCreateEmployeePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeCreateEmployeePost$Json$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeCreateEmployeePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeCreateEmployeePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeCreateEmployeePost$Json(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeCreateEmployeePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEditEmployeePost
   */
  static readonly ApiEmployeeEditEmployeePostPath = '/api/Employee/edit-employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePost$Plain$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePost$Plain(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEditEmployeePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePost$Json$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePost$Json(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEditEmployeePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEditEmployeeUserPost
   */
  static readonly ApiEmployeeEditEmployeeUserPostPath = '/api/Employee/edit-employee-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeeUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeUserPost$Plain$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeeUserPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeeUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeUserPost$Plain(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEditEmployeeUserPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeeUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeUserPost$Json$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeeUserPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeeUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeUserPost$Json(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEditEmployeeUserPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEditEmployeePersonalPost
   */
  static readonly ApiEmployeeEditEmployeePersonalPostPath = '/api/Employee/edit-employee-personal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeePersonalPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePersonalPost$Plain$Response(params?: {
    body?: EmployeePersonalDetails
  }): Observable<StrictHttpResponse<EmployeePersonalDetailsDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeePersonalPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeePersonalDetailsDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeePersonalPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePersonalPost$Plain(params?: {
    body?: EmployeePersonalDetails
  }): Observable<EmployeePersonalDetailsDlmBaseResponse> {

    return this.apiEmployeeEditEmployeePersonalPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeePersonalDetailsDlmBaseResponse>) => r.body as EmployeePersonalDetailsDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeePersonalPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePersonalPost$Json$Response(params?: {
    body?: EmployeePersonalDetails
  }): Observable<StrictHttpResponse<EmployeePersonalDetailsDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeePersonalPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeePersonalDetailsDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeePersonalPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeePersonalPost$Json(params?: {
    body?: EmployeePersonalDetails
  }): Observable<EmployeePersonalDetailsDlmBaseResponse> {

    return this.apiEmployeeEditEmployeePersonalPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeePersonalDetailsDlmBaseResponse>) => r.body as EmployeePersonalDetailsDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEditEmployeeEmploymentPost
   */
  static readonly ApiEmployeeEditEmployeeEmploymentPostPath = '/api/Employee/edit-employee-employment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeeEmploymentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeEmploymentPost$Plain$Response(params?: {
    body?: EmployeeEmploymentDetails
  }): Observable<StrictHttpResponse<EmployeeEmploymentDetailsDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeeEmploymentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeEmploymentDetailsDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeeEmploymentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeEmploymentPost$Plain(params?: {
    body?: EmployeeEmploymentDetails
  }): Observable<EmployeeEmploymentDetailsDlmBaseResponse> {

    return this.apiEmployeeEditEmployeeEmploymentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeEmploymentDetailsDlmBaseResponse>) => r.body as EmployeeEmploymentDetailsDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEditEmployeeEmploymentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeEmploymentPost$Json$Response(params?: {
    body?: EmployeeEmploymentDetails
  }): Observable<StrictHttpResponse<EmployeeEmploymentDetailsDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEditEmployeeEmploymentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeEmploymentDetailsDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEditEmployeeEmploymentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeEditEmployeeEmploymentPost$Json(params?: {
    body?: EmployeeEmploymentDetails
  }): Observable<EmployeeEmploymentDetailsDlmBaseResponse> {

    return this.apiEmployeeEditEmployeeEmploymentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeEmploymentDetailsDlmBaseResponse>) => r.body as EmployeeEmploymentDetailsDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeDeleteEmployeePost
   */
  static readonly ApiEmployeeDeleteEmployeePostPath = '/api/Employee/delete-employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeDeleteEmployeePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeDeleteEmployeePost$Plain$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeDeleteEmployeePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeDeleteEmployeePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeDeleteEmployeePost$Plain(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeDeleteEmployeePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeDeleteEmployeePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeDeleteEmployeePost$Json$Response(params?: {
    body?: EmployeeResponse
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeDeleteEmployeePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeDeleteEmployeePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeDeleteEmployeePost$Json(params?: {
    body?: EmployeeResponse
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeDeleteEmployeePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeJobTitlesGet
   */
  static readonly ApiEmployeeJobTitlesGetPath = '/api/Employee/job-titles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeJobTitlesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeJobTitlesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DlmAccessLevel>>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeJobTitlesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DlmAccessLevel>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeJobTitlesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeJobTitlesGet$Plain(params?: {
  }): Observable<Array<DlmAccessLevel>> {

    return this.apiEmployeeJobTitlesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DlmAccessLevel>>) => r.body as Array<DlmAccessLevel>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeJobTitlesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeJobTitlesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DlmAccessLevel>>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeJobTitlesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DlmAccessLevel>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeJobTitlesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeJobTitlesGet$Json(params?: {
  }): Observable<Array<DlmAccessLevel>> {

    return this.apiEmployeeJobTitlesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DlmAccessLevel>>) => r.body as Array<DlmAccessLevel>)
    );
  }

  /**
   * Path part for operation apiEmployeeRestorePost
   */
  static readonly ApiEmployeeRestorePostPath = '/api/Employee/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeRestorePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeRestorePost$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeRestorePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeRestorePost$Plain(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiEmployeeRestorePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeRestorePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeRestorePost$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeRestorePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeRestorePost$Json(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiEmployeeRestorePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiEmployeeEmployeeBackupPost
   */
  static readonly ApiEmployeeEmployeeBackupPostPath = '/api/Employee/employee-backup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeBackupPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeBackupPost$Plain$Response(params?: {
    email?: string;
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeBackupPostPath, 'post');
    if (params) {
      rb.query('email', params.email, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeBackupPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeBackupPost$Plain(params?: {
    email?: string;
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEmployeeBackupPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeEmployeeBackupPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeBackupPost$Json$Response(params?: {
    email?: string;
  }): Observable<StrictHttpResponse<EmployeeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, EmployeeService.ApiEmployeeEmployeeBackupPostPath, 'post');
    if (params) {
      rb.query('email', params.email, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmployeeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeEmployeeBackupPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeEmployeeBackupPost$Json(params?: {
    email?: string;
  }): Observable<EmployeeResponseDlmBaseResponse> {

    return this.apiEmployeeEmployeeBackupPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<EmployeeResponseDlmBaseResponse>) => r.body as EmployeeResponseDlmBaseResponse)
    );
  }

}
